
// stnads for the theme options dropdown at subscription process page 2

const themeData = 

[
  {
    name: "Modern SaaS",
    scheme_colors: {
      primary_color: "rgb(15, 23, 42)",      // Dark slate background
      secondary_color: "rgb(30, 41, 59)",     // Lighter slate for sections
      accent_color: "rgb(99, 102, 241)"       // Indigo text/CTAs
    }
  },
  {
    name: "Clean Professional",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // White background
      secondary_color: "rgb(248, 250, 252)",  // Light gray sections
      accent_color: "rgb(14, 165, 233)"       // Sky blue text/links
    }
  },
  {
    name: "Tech Startup",
    scheme_colors: {
      primary_color: "rgb(17, 24, 39)",       // Dark gray background
      secondary_color: "rgb(31, 41, 55)",     // Medium gray sections
      accent_color: "rgb(34, 211, 238)"       // Cyan text/highlights
    }
  },
  {
    name: "Elegant Dark",
    scheme_colors: {
      primary_color: "rgb(24, 24, 27)",       // Near black background
      secondary_color: "rgb(39, 39, 42)",     // Dark zinc sections
      accent_color: "rgb(250, 204, 21)"       // Gold text/accents
    }
  },
  {
    name: "Corporate Blue",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // White background
      secondary_color: "rgb(241, 245, 249)",  // Slate sections
      accent_color: "rgb(30, 64, 175)"        // Deep blue text/CTAs
    }
  },
  {
    name: "Creative Purple",
    scheme_colors: {
      primary_color: "rgb(250, 250, 250)",    // Off-white background
      secondary_color: "rgb(243, 244, 246)",  // Gray sections
      accent_color: "rgb(147, 51, 234)"       // Purple text/buttons
    }
  },
  {
    name: "Fresh Green",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // White background
      secondary_color: "rgb(240, 253, 244)",  // Light green sections
      accent_color: "rgb(22, 163, 74)"        // Green text/CTAs
    }
  },
  {
    name: "Minimalist Gray",
    scheme_colors: {
      primary_color: "rgb(249, 250, 251)",    // Very light gray background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(55, 65, 81)"         // Dark gray text/links
    }
  },
  {
    name: "Bold Orange",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // White background
      secondary_color: "rgb(255, 247, 237)",  // Warm sections
      accent_color: "rgb(234, 88, 12)"        // Orange text/CTAs
    }
  },
  {
    name: "Night Mode",
    scheme_colors: {
      primary_color: "rgb(12, 12, 12)",       // Almost black background
      secondary_color: "rgb(23, 23, 23)",     // Dark sections
      accent_color: "rgb(168, 85, 247)"       // Purple text/accents
    }
  },
  {
    name: "Ocean Blue",
    scheme_colors: {
      primary_color: "rgb(240, 249, 255)",    // Light blue background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(2, 132, 199)"        // Ocean blue text/CTAs
    }
  },
  {
    name: "Sunset Coral",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // White background
      secondary_color: "rgb(255, 241, 242)",  // Light pink sections
      accent_color: "rgb(244, 63, 94)"        // Coral text/buttons
    }
  },
  {
    name: "Forest Green",
    scheme_colors: {
      primary_color: "rgb(20, 83, 45)",       // Dark green background
      secondary_color: "rgb(34, 107, 61)",    // Medium green sections
      accent_color: "rgb(187, 247, 208)"      // Light green text/accents
    }
  },
  {
    name: "Luxury Gold",
    scheme_colors: {
      primary_color: "rgb(31, 41, 55)",       // Dark background
      secondary_color: "rgb(55, 65, 81)",     // Gray sections
      accent_color: "rgb(251, 191, 36)"       // Gold text/highlights
    }
  },
  {
    name: "Soft Lavender",
    scheme_colors: {
      primary_color: "rgb(253, 251, 254)",    // Light lavender background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(126, 34, 206)"       // Purple text/CTAs
    }
  },
  {
    name: "Deep Navy",
    scheme_colors: {
      primary_color: "rgb(15, 23, 42)",       // Navy background
      secondary_color: "rgb(30, 41, 59)",     // Lighter navy sections
      accent_color: "rgb(56, 189, 248)"       // Light blue text/accents
    }
  },
  {
    name: "Warm Beige",
    scheme_colors: {
      primary_color: "rgb(250, 247, 242)",    // Beige background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(120, 53, 15)"        // Brown text/CTAs
    }
  },
  {
    name: "Electric Blue",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // White background
      secondary_color: "rgb(239, 246, 255)",  // Light blue sections
      accent_color: "rgb(37, 99, 235)"        // Bright blue text/buttons
    }
  },
  {
    name: "Slate Professional",
    scheme_colors: {
      primary_color: "rgb(241, 245, 249)",    // Light slate background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(51, 65, 85)"         // Dark slate text/links
    }
  },
  {
    name: "Ruby Red",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // White background
      secondary_color: "rgb(254, 242, 242)",  // Light red sections
      accent_color: "rgb(220, 38, 38)"        // Red text/CTAs
    }
  },
  {
    name: "Teal Modern",
    scheme_colors: {
      primary_color: "rgb(240, 253, 250)",    // Light teal background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(13, 148, 136)"       // Teal text/buttons
    }
  },
  {
    name: "Charcoal Dark",
    scheme_colors: {
      primary_color: "rgb(38, 38, 38)",       // Charcoal background
      secondary_color: "rgb(64, 64, 64)",     // Gray sections
      accent_color: "rgb(245, 158, 11)"       // Amber text/accents
    }
  },
  {
    name: "Mint Fresh",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // White background
      secondary_color: "rgb(236, 253, 245)",  // Mint sections
      accent_color: "rgb(5, 150, 105)"        // Emerald text/CTAs
    }
  },
  {
    name: "Plum Premium",
    scheme_colors: {
      primary_color: "rgb(250, 245, 255)",    // Light plum background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(109, 40, 217)"       // Plum text/buttons
    }
  },
  {
    name: "Monochrome Light",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // White background
      secondary_color: "rgb(250, 250, 250)",  // Off-white sections
      accent_color: "rgb(23, 23, 23)"         // Black text/CTAs
    }
  },
  {
    name: "Sky Light",
    scheme_colors: {
      primary_color: "rgb(224, 242, 254)",    // Sky blue background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(3, 105, 161)"        // Deep sky text/links
    }
  },
  {
    name: "Rose Gold",
    scheme_colors: {
      primary_color: "rgb(255, 251, 235)",    // Cream background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(190, 24, 93)"        // Rose text/accents
    }
  },
  {
    name: "Carbon Fiber",
    scheme_colors: {
      primary_color: "rgb(23, 23, 23)",       // Near black background
      secondary_color: "rgb(38, 38, 38)",     // Dark sections
      accent_color: "rgb(156, 163, 175)"      // Gray text/highlights
    }
  },
  {
    name: "Lime Energy",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // White background
      secondary_color: "rgb(247, 254, 231)",  // Light lime sections
      accent_color: "rgb(132, 204, 22)"       // Lime text/CTAs
    }
  },
  {
    name: "Indigo Deep",
    scheme_colors: {
      primary_color: "rgb(30, 27, 75)",       // Deep indigo background
      secondary_color: "rgb(49, 46, 129)",    // Medium indigo sections
      accent_color: "rgb(165, 180, 252)"      // Light indigo text/accents
    }
  },
  {
    name: "Peach Soft",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // White background
      secondary_color: "rgb(254, 243, 235)",  // Peach sections
      accent_color: "rgb(234, 88, 12)"        // Orange text/buttons
    }
  },
  {
    name: "Steel Blue",
    scheme_colors: {
      primary_color: "rgb(248, 250, 252)",    // Light steel background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(71, 85, 105)"        // Steel blue text/CTAs
    }
  },
  {
    name: "Emerald Elegant",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // White background
      secondary_color: "rgb(236, 253, 245)",  // Light emerald sections
      accent_color: "rgb(16, 185, 129)"       // Emerald text/buttons
    }
  },
  {
    name: "Burgundy Rich",
    scheme_colors: {
      primary_color: "rgb(76, 5, 25)",        // Dark burgundy background
      secondary_color: "rgb(127, 29, 29)",    // Medium burgundy sections
      accent_color: "rgb(252, 231, 243)"      // Pink text/accents
    }
  },
  {
    name: "Arctic White",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // Pure white background
      secondary_color: "rgb(241, 245, 249)",  // Cool gray sections
      accent_color: "rgb(100, 116, 139)"      // Slate text/links
    }
  },
  {
    name: "Sunset Orange",
    scheme_colors: {
      primary_color: "rgb(255, 247, 237)",    // Warm orange background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(194, 65, 12)"        // Deep orange text/CTAs
    }
  },
  {
    name: "Violet Night",
    scheme_colors: {
      primary_color: "rgb(35, 5, 63)",        // Dark violet background
      secondary_color: "rgb(59, 7, 100)",     // Medium violet sections
      accent_color: "rgb(196, 181, 253)"      // Light violet text/accents
    }
  },
  {
    name: "Concrete Modern",
    scheme_colors: {
      primary_color: "rgb(245, 245, 245)",    // Light concrete background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(75, 85, 99)"         // Dark gray text/buttons
    }
  },
  {
    name: "Tropical Cyan",
    scheme_colors: {
      primary_color: "rgb(236, 254, 255)",    // Light cyan background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(6, 182, 212)"        // Cyan text/CTAs
    }
  },
  {
    name: "Autumn Brown",
    scheme_colors: {
      primary_color: "rgb(254, 252, 232)",    // Warm cream background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(146, 64, 14)"        // Brown text/links
    }
  },
  {
    name: "Midnight Purple",
    scheme_colors: {
      primary_color: "rgb(24, 24, 27)",       // Near black background
      secondary_color: "rgb(39, 39, 42)",     // Dark zinc sections
      accent_color: "rgb(192, 132, 252)"      // Purple text/accents
    }
  },
  {
    name: "Spring Green",
    scheme_colors: {
      primary_color: "rgb(247, 254, 231)",    // Light lime background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(101, 163, 13)"       // Lime green text/CTAs
    }
  },
  {
    name: "Cherry Blossom",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // White background
      secondary_color: "rgb(253, 242, 248)",  // Light pink sections
      accent_color: "rgb(219, 39, 119)"       // Pink text/buttons
    }
  },
  {
    name: "Obsidian Black",
    scheme_colors: {
      primary_color: "rgb(9, 9, 11)",         // Obsidian background
      secondary_color: "rgb(24, 24, 27)",     // Dark sections
      accent_color: "rgb(228, 228, 231)"      // Light gray text/accents
    }
  },
  {
    name: "Aqua Fresh",
    scheme_colors: {
      primary_color: "rgb(255, 255, 255)",    // White background
      secondary_color: "rgb(236, 254, 255)",  // Aqua sections
      accent_color: "rgb(8, 145, 178)"        // Aqua text/CTAs
    }
  },
  {
    name: "Golden Hour",
    scheme_colors: {
      primary_color: "rgb(255, 251, 235)",    // Warm background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(217, 119, 6)"        // Amber text/buttons
    }
  },
  {
    name: "Graphite Pro",
    scheme_colors: {
      primary_color: "rgb(82, 82, 91)",       // Graphite background
      secondary_color: "rgb(113, 113, 122)",  // Light graphite sections
      accent_color: "rgb(250, 250, 250)"      // White text/accents
    }
  },
  {
    name: "Seafoam",
    scheme_colors: {
      primary_color: "rgb(240, 253, 250)",    // Seafoam background
      secondary_color: "rgb(255, 255, 255)",  // White sections
      accent_color: "rgb(15, 118, 110)"       // Teal text/CTAs
    }
  },
  {
    name: "Cosmic Purple",
    scheme_colors: {
      primary_color: "rgb(46, 16, 101)",      // Deep purple background
      secondary_color: "rgb(88, 28, 135)",    // Medium purple sections
      accent_color: "rgb(233, 213, 255)"      // Light purple text/accents
    }
  }
];



// [
//   {
//     name: "High-Tech Elegance",
//     scheme_colors: {
//       primary_color: "rgb(34, 40, 49)",
//       secondary_color: "rgb(0, 52, 102)",
//       accent_color: "rgb(240, 240, 240)"
//     }
//   },
//   {
//     name: "Clean Freshness",
//     scheme_colors: {
//       primary_color: "rgb(170, 230, 200)",
//       secondary_color: "rgb(255, 255, 255)",
//       accent_color: "rgb(125, 124, 124)"
//     }
//   },
//   {
//     name: "Reliable Luxury",
//     scheme_colors: {
//       primary_color: "rgb(25, 25, 112)",
//       secondary_color: "rgb(255, 253, 208)",
//       accent_color: "rgb(218, 165, 32, 0.7)"
//     }
//   },
//   {
//     name: "Soft Chic",
//     scheme_colors: {
//       primary_color: "rgb(221, 160, 221)",
//       secondary_color: "rgb(245, 245, 220)",
//       accent_color: "rgb(54, 69, 79)"
//     }
//   },
//   {
//     name: "Rich Creativity",
//     scheme_colors: {
//       primary_color: "rgb(227, 101, 11)",
//       secondary_color: "rgb(255, 255, 240)",
//       accent_color: "rgb(73, 87, 101)"
//     }
//   },
//   {
//     name: "Dynamic Turquoise",
//     scheme_colors: {
//       primary_color: "rgb(0, 128, 128)",
//       secondary_color: "rgb(255, 255, 255)",
//       accent_color: "rgb(218, 187, 11)"
//     }
//   },
//   {
//     name: "Innovative Purple",
//     scheme_colors: {
//       primary_color: "rgb(72, 61, 139)",
//       secondary_color: "rgb(240, 240, 240)",
//       accent_color: "rgb(147, 147, 147)"
//     }
//   },
//   {
//     name: "Natural & Earthy",
//     scheme_colors: {
//       primary_color: "rgb(128, 128, 0)",
//       secondary_color: "rgb(249, 246, 238)",
//       accent_color: "rgb(108, 54, 15)"
//     }
//   },
//   {
//     name: "Professional Pop",
//     scheme_colors: {
//       primary_color: "rgb(65, 105, 225)",
//       secondary_color: "rgb(90, 90, 90)",
//       accent_color: "rgb(255, 255, 153)"
//     }
//   },
//   {
//     name: "Dramatic Bordeaux",
//     scheme_colors: {
//       primary_color: "rgb(128, 0, 32)",
//       secondary_color: "rgb(42, 42, 42)",
//       accent_color: "rgb(245, 245, 220)"
//     }
//   },
//   {
//     name: "Clear Skies",
//     scheme_colors: {
//       primary_color: "rgb(173, 216, 230)",
//       secondary_color: "rgb(255, 255, 255)",
//       accent_color: "rgb(0, 0, 128)"
//     }
//   },
//   {
//     name: "Futuristic Metallic",
//     scheme_colors: {
//       primary_color: "rgb(20, 20, 20)",
//       secondary_color: "rgb(192, 192, 192, 0.8)",
//       accent_color: "rgb(112, 128, 144)"
//     }
//   },
//   {
//     name: "Vibrant Coral",
//     scheme_colors: {
//       primary_color: "rgb(240, 128, 128)",
//       secondary_color: "rgb(255, 255, 255)",
//       accent_color: "rgb(0, 100, 0)"
//     }
//   },
//   {
//     name: "Navy Crisp",
//     scheme_colors: {
//       primary_color: "rgb(0, 0, 128)",
//       secondary_color: "rgb(255, 255, 255)",
//       accent_color: "rgb(220, 220, 90)"
//     }
//   },
//   {
//     name: "Rich Chocolate",
//     scheme_colors: {
//       primary_color: "rgb(139, 69, 19)",
//       secondary_color: "rgb(245, 245, 220)",
//       accent_color: "rgb(255, 223, 0, 0.6)"
//     }
//   },
//   {
//     name: "Minimalist Calm",
//     scheme_colors: {
//       primary_color: "rgb(50, 54, 51)",
//       secondary_color: "rgb(255, 253, 208)",
//       accent_color: "rgb(198, 156, 100)"
//     }
//   },
//   {
//     name: "Focused Orange",
//     scheme_colors: {
//       primary_color: "rgb(232, 94, 44)",
//       secondary_color: "rgb(255, 255, 255)",
//       accent_color: "rgb(64, 64, 64)"
//     }
//   },
//   {
//     name: "Bold Fuchsia",
//     scheme_colors: {
//       primary_color: "rgb(0, 0, 0)",
//       secondary_color: "rgb(255, 255, 255)",
//       accent_color: "rgb(255, 0, 255)"
//     }
//   },
//   {
//     name: "Luxurious Forest",
//     scheme_colors: {
//       primary_color: "rgb(45, 163, 45)",
//       secondary_color: "rgb(255, 255, 240)",
//       accent_color: "rgb(122, 72, 21)"
//     }
//   },
//   {
//     name: "Soothing Lavender",
//     scheme_colors: {
//       primary_color: "rgb(196, 152, 217)",
//       secondary_color: "rgb(255, 255, 255)",
//       accent_color: "rgb(45, 95, 136)"
//     }
//   },
//   {
//     name: "Classic Monochrome",
//     scheme_colors: {
//       primary_color: "rgb(24, 24, 24)",
//       secondary_color: "rgb(245, 245, 245)",
//       accent_color: "rgb(150, 150, 150)"
//     }
//   },
//   {
//     name: "Subtle Earth",
//     scheme_colors: {
//       primary_color: "rgb(60, 48, 30)",
//       secondary_color: "rgb(255, 250, 240)",
//       accent_color: "rgb(188, 143, 143)"
//     }
//   },
//   {
//     name: "Deep Ocean",
//     scheme_colors: {
//       primary_color: "rgb(1, 48, 90)",
//       secondary_color: "rgb(220, 240, 255)",
//       accent_color: "rgb(180, 205, 230)"
//     }
//   },
//   {
//     name: "Modern Lavender",
//     scheme_colors: {
//       primary_color: "rgb(105, 90, 166)",
//       secondary_color: "rgb(250, 240, 255)",
//       accent_color: "rgb(190, 175, 220)"
//     }
//   },
//   {
//     name: "Fresh Mint",
//     scheme_colors: {
//       primary_color: "rgb(41, 172, 172)",
//       secondary_color: "rgb(240, 255, 240)",
//       accent_color: "rgb(14, 75, 75)"
//     }
//   },
//   {
//     name: "Warm Sunset",
//     scheme_colors: {
//       primary_color: "rgb(253, 141, 100)",
//       secondary_color: "rgb(255, 250, 240)",
//       accent_color: "rgb(179, 73, 73)"
//     }
//   },
//   {
//     name: "Elegant Teal",
//     scheme_colors: {
//       primary_color: "rgb(0, 102, 102)",
//       secondary_color: "rgb(240, 255, 255)",
//       accent_color: "rgb(2, 173, 173)"
//     }
//   },
//   {
//     name: "Professional Gray",
//     scheme_colors: {
//       primary_color: "rgb(47, 79, 79)",
//       secondary_color: "rgb(248, 248, 248)",
//       accent_color: "rgb(161, 160, 160)"
//     }
//   },
//   {
//     name: "Dusty Rose",
//     scheme_colors: {
//       primary_color: "rgb(219, 176, 176)",
//       secondary_color: "rgb(255, 240, 245)",
//       accent_color: "rgb(140, 95, 95)"
//     }
//   },
//   {
//     name: "Olive & Cream",
//     scheme_colors: {
//       primary_color: "rgb(128, 128, 0)",
//       secondary_color: "rgb(255, 255, 240)",
//       accent_color: "rgb(60, 60, 60)"
//     }
//   },
//   {
//     name: "Calm Serenity",
//     scheme_colors: {
//       primary_color: "rgb(176, 196, 222)",
//       secondary_color: "rgb(240, 248, 255)",
//       accent_color: "rgb(119, 136, 153)"
//     }
//   },
//   {
//     name: "Charcoal & Gold",
//     scheme_colors: {
//       primary_color: "rgb(54, 69, 79)",
//       secondary_color: "rgb(255, 255, 240)",
//       accent_color: "rgb(218, 165, 32)"
//     }
//   },
//   {
//     name: "Muted Forest",
//     scheme_colors: {
//       primary_color: "rgb(85, 107, 47)",
//       secondary_color: "rgb(245, 245, 220)",
//       accent_color: "rgb(175, 175, 100)"
//     }
//   },
//   {
//     name: "Warm Brick",
//     scheme_colors: {
//       primary_color: "rgb(210, 60, 60)",
//       secondary_color: "rgb(255, 250, 240)",
//       accent_color: "rgb(90, 44, 12)"
//     }
//   },
//   {
//     name: "Desert Sands",
//     scheme_colors: {
//       primary_color: "rgb(193, 154, 107)",
//       secondary_color: "rgb(255, 253, 208)",
//       accent_color: "rgb(139, 90, 43)"
//     }
//   },
//   {
//     name: "Classic Slate",
//     scheme_colors: {
//       primary_color: "rgb(47, 79, 79)",
//       secondary_color: "rgb(248, 248, 255)",
//       accent_color: "rgb(128, 128, 128)"
//     }
//   },
//   {
//     name: "Pastel Dreams",
//     scheme_colors: {
//       primary_color: "rgb(255, 182, 193)",
//       secondary_color: "rgb(255, 255, 255)",
//       accent_color: "rgb(106, 90, 205)"
//     }
//   },
//   {
//     name: "Midnight Blue",
//     scheme_colors: {
//       primary_color: "rgb(25, 25, 112)",
//       secondary_color: "rgb(245, 245, 245)",
//       accent_color: "rgb(173, 216, 230)"
//     }
//   },
//   {
//     name: "Lavender Field",
//     scheme_colors: {
//       primary_color: "rgb(208, 102, 235)",
//       secondary_color: "rgb(255, 255, 255)",
//       accent_color: "rgb(95, 79, 189)"
//     }
//   },
//   {
//     name: "Steel & Rust",
//     scheme_colors: {
//       primary_color: "rgb(70, 80, 90)",
//       secondary_color: "rgb(255, 250, 250)",
//       accent_color: "rgb(181, 92, 4)"
//     }
//   },
//   {
//     name: "Minty Fresh",
//     scheme_colors: {
//       primary_color: "rgb(0, 191, 143)",
//       secondary_color: "rgb(245, 255, 250)",
//       accent_color: "rgb(0, 100, 100)"
//     }
//   },
//   {
//     name: "Warm Neutral",
//     scheme_colors: {
//       primary_color: "rgb(177, 153, 128)",
//       secondary_color: "rgb(255, 255, 245)",
//       accent_color: "rgb(110, 100, 80)"
//     }
//   },
//   {
//     name: "Deep Merlot",
//     scheme_colors: {
//       primary_color: "rgb(115, 0, 0)",
//       secondary_color: "rgb(250, 235, 215)",
//       accent_color: "rgb(205, 133, 63)"
//     }
//   },
//   {
//     name: "Sunny Citrus",
//     scheme_colors: {
//       primary_color: "rgb(206, 134, 0)",
//       secondary_color: "rgb(255, 255, 255)",
//       accent_color: "rgb(250, 216, 18)"
//     }
//   },
//   {
//     name: "Ocean Breeze",
//     scheme_colors: {
//       primary_color: "rgb(135, 206, 250)",
//       secondary_color: "rgb(255, 255, 255)",
//       accent_color: "rgb(0, 128, 128)"
//     }
//   },
//   {
//     name: "Industrial Chic",
//     scheme_colors: {
//       primary_color: "rgb(65, 65, 65)",
//       secondary_color: "rgb(240, 240, 240)",
//       accent_color: "rgb(180, 180, 180)"
//     }
//   },
//   {
//     name: "Grapevine",
//     scheme_colors: {
//       primary_color: "rgb(77, 1, 96)",
//       secondary_color: "rgb(255, 255, 255)",
//       accent_color: "rgb(166, 15, 232)"
//     }
//   },
//   {
//     name: "Forest & Stone",
//     scheme_colors: {
//       primary_color: "rgb(0, 50, 0)",
//       secondary_color: "rgb(230, 230, 230)",
//       accent_color: "rgb(139, 69, 19)"
//     }
//   },
//   {
//     name: "Vintage Teal",
//     scheme_colors: {
//       primary_color: "rgb(0, 100, 100)",
//       secondary_color: "rgb(255, 255, 240)",
//       accent_color: "rgb(218, 165, 32)"
//     }
//   },
//   {
//     name: "Silver & Plum",
//     scheme_colors: {
//       primary_color: "rgb(75, 0, 130)",
//       secondary_color: "rgb(170, 170, 170)",
//       accent_color: "rgb(255, 255, 255)"
//     }
//   }
// ];

export default themeData;